import React, { createContext, useContext, ReactNode } from 'react';

export type AssignmentProps = {
  id?: number | null;
  status?: string | null;
};

interface AssignmentContextType {
  assignment: AssignmentProps | null;
  setAssignment: (assignment: AssignmentProps | null) => void;
}

const AssignmentContext = createContext<AssignmentContextType | undefined>(undefined);

interface AssignmentProviderProps {
  children: ReactNode;
}

export const AssignmentProvider: React.FC<AssignmentProviderProps> = ({ children }) => {
  const [assignment, setAssignment] = React.useState<AssignmentProps | null>(null);

  return (
    <AssignmentContext.Provider value={{ assignment, setAssignment }}>
      {children}
    </AssignmentContext.Provider>
  );
};

export const useAssignmentContext = (): AssignmentContextType => {
  const context = useContext(AssignmentContext);
  if (context === undefined) {
    throw new Error('useAssignmentContext must be used within an AssignmentProvider');
  }
  return context;
};
